/* Punartha storefront navigation: hover-open on fine pointers, accessible
   click/keyboard disclosure everywhere, and Nalli-inspired rail-to-panel swaps. */
(function () {
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var closeDelay = 160;

  function activateTab(surface, tab) {
    var targetId = tab.getAttribute('data-mega-tab');
    if (!targetId) return;

    surface.querySelectorAll('[data-mega-tab]').forEach(function (candidate) {
      var active = candidate === tab;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    surface.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
      var active = panel.id === targetId;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  function initializeMenu(menu) {
    if (menu.dataset.punarthaNavReady === 'true') return;

    var details = menu.querySelector('details.mega-menu');
    var summary = details && details.querySelector(':scope > summary');
    var surface = details && details.querySelector('[data-mega-menu-surface]');
    var timer;

    if (!details || !summary) return;
    menu.dataset.punarthaNavReady = 'true';

    function closeMenu() {
      timer = window.setTimeout(function () {
        details.open = false;
      }, closeDelay);
    }

    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });

    if (finePointer.matches) {
      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(timer);
        details.open = true;
      });
      menu.addEventListener('mouseleave', closeMenu);
    }

    menu.addEventListener('focusin', function () {
      window.clearTimeout(timer);
    });
    menu.addEventListener('focusout', function (event) {
      if (!menu.contains(event.relatedTarget)) closeMenu();
    });
    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      details.open = false;
      summary.focus();
    });

    if (!surface) return;

    surface.querySelectorAll('[data-mega-tab]').forEach(function (tab) {
      tab.addEventListener('pointerenter', function () {
        activateTab(surface, tab);
      });
      tab.addEventListener('focus', function () {
        activateTab(surface, tab);
      });
      tab.addEventListener('click', function (event) {
        if (finePointer.matches || tab.classList.contains('is-active')) return;
        event.preventDefault();
        activateTab(surface, tab);
      });
    });
  }

  function initialize(root) {
    root.querySelectorAll('header-menu').forEach(initializeMenu);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
